import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { useNavigate } from 'react-router-dom';
import { axiosNoAuth } from '../config/axiosInstance';
import { NINJACURATE_BACKEND_BASE_URL } from '../config/api_config';

export const fetchCourses = createAsyncThunk(
    'courses/fetch',
    async ({uuid, skillName, skillLevel, userKnows, userMissed}) => {
        const maxRetries = 2;
        let retries = 0;
        while (retries < maxRetries) {
            try {
                const response = await axiosNoAuth.post(`${NINJACURATE_BACKEND_BASE_URL}/course_generate`, {
                    uid:uuid, skill_name: skillName, skill_difficulty: skillLevel, user_knows: userKnows, user_missed: userMissed
                });
                if (response.data === true || response.data === false) {
                    const navigate = useNavigate()
                    navigate('/')
                    return;
                }
                return response.data;
            } catch (err) {
                console.log(err);
                retries += 1;
            }
        }
    }
)

const initialState = {
    courses: {},
    proMembershipSelected: false,
    placementSupportSelected: false,
}

const coursesSlice = createSlice({
    name: 'courses',
    initialState,
    reducers: {
        setCourseData: (state, action) => {
            state.courses = action.payload
        },
        setProMembershipSelected: (state, action) => {
            state.proMembershipSelected = action.payload
        },
        setPlacementSupportSelected: (state, action) => {
            state.placementSupportSelected = action.payload
        },
        resetCourseData: (state) => initialState
    },
    extraReducers: (builder) => {
        builder.addCase(fetchCourses.fulfilled, (state, action) => {
            state.courses =  action.payload;
        });
    },
});

export const { resetCourseData, setCourseData, setProMembershipSelected, setPlacementSupportSelected } = coursesSlice.actions
export const selectCourses = (state) => state.courses.courses
export const selectProMembershipSelected = (state) => state.courses.proMembershipSelected
export const selectPlacementSupportSelected = (state) => state.courses.placementSupportSelected
export default coursesSlice.reducer
